import { useMemo } from "react";
import { get_processes_list } from "../../api";
import { useKeyedRequest } from "../../utils/useKeyedRequest";
import { localDayBounds } from "./dateSelection";
import { EMPTY_PROCESS_OVERVIEW, summarizeProcessOverview } from "./processOverview";

/** The processes `userIds` ran in the picked local days, each broken down by person. */
export function useProcessList(
  userIds: string[],
  from: string,
  to: string,
  enabled = true,
  revision = 0,
) {
  const scope = [...userIds].sort();
  const key = scope.join(",");
  return useKeyedRequest(
    enabled && key ? JSON.stringify([key, from, to, revision]) : null,
    signal => get_processes_list({ user_ids: scope, ...localDayBounds(from, to) }, signal),
  );
}

export function useProcessOverview(
  userIds: string[],
  from: string,
  to: string,
  enabled = true,
  revision = 0,
) {
  const request = useProcessList(userIds, from, to, enabled, revision);
  const metrics = useMemo(
    () => (request.data ? summarizeProcessOverview(request.data) : EMPTY_PROCESS_OVERVIEW),
    [request.data],
  );
  return { metrics, loading: request.loading, error: request.failed, reload: request.reload };
}
